import React, { Component } from "react";
import { Growl } from "primereact/growl";
import { InputText } from 'primereact/inputtext';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import servicioHttp from "../servicio/ServicioHttp";
import { Message } from "primereact/message";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import servicioObjetos from '../servicio/ServicioObjetos';
import { DEFAULT_MASKS } from '../servicio/ServicioConstantes';
export class TablaDetalle extends Component {
    constructor() {
        super();
        this.state = {
            desarrollador: false,
            mostrarModalConfirmacion: false,
            detalle: {},
            mostrarModalDetalle: false,
            errores: {},
            idsenube: 0,
            paginacion: {
                registrosPorPagina: 100,
                registrosTotales: 0,
                join: null,
                restriccionesDinamicas: [
                ]
            },
        }

    }
    componentDidMount() {
        this.obtenerResultados();
        this.obtnerUsuarioDesarrollador();
    }
    obtnerUsuarioDesarrollador = () => {
        servicioHttp.consumirPostHttp('usuario/obtener_usuario_sesion_perfil.json').then(response => {
            if (response.data.mensaje === "existe") {
                this.setState({ desarrollador: true });
            }
        }).catch(error => {
        });
    }
    asignar_restricciones = () => {
        let { paginacion } = this.state;
        paginacion.restriccionesDinamicas = [];
    }
    obtenerResultados = () => {
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('imss_detalle/consultar.json', paginacion).then(response => {
            this.setState({ paginacion: response.data.objeto })
        }).catch(error => {

        });
    }
    guardarDetalle = () => {
        let { detalle } = this.state;
        servicioHttp.consumirPostHttp('imss_detalle/guardar.json', detalle).then(response => {
            this.setState({ mostrarModalDetalle: false, detalle: {} })
            this.obtenerResultados();
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "No se guardo la información", life: 6000 });
        });

    }
    mostrarModalDetalle = () => {
        this.setState({ mostrarModalDetalle: true });

    }
    cerrarModal = () => {
        this.setState({ mostrarModalDetalle: false });
    }
    preeditar = (rowData) => {
        let detalle = JSON.parse(JSON.stringify(rowData));
        this.setState({ detalle: detalle, mostrarModalDetalle: true });
    }
    plantillaOpciones = (rowData, column) => {
        let { desarrollador } = this.state;
        return <div className="p-grid">
            <div className="p-col-12 p-md-6">
                {desarrollador ?
                    <Button type="button" icon="pi-md-edit" onClick={(e) => this.preeditar(rowData)}
                        className="p-button-warning" name="editar" tooltip="Editar">
                    </Button>
                    : null}
            </div>
            <div className="p-col-12 p-md-6">
                {desarrollador ?
                    <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(rowData)}
                        className="p-button-danger" name="eliminar" tooltip="Eliminar">
                    </Button>
                    : null}
            </div>
        </div>;
    }
    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }
    mostrarModalEliminar = (rowData) => {
        let detalle = JSON.parse(JSON.stringify(rowData));
        this.setState({ detalle: detalle, mostrarModalConfirmacion: true });
    }

    eliminar = () => {
        let { detalle } = this.state;
        servicioHttp.consumirPostHttp('imss_detalle/eliminar.json', detalle).then(response => {
            this.setState({ mostrarModalActualizarPatron: false, detalle: {}, mostrarModalConfirmacion: false })
            this.obtenerResultados();
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "No se elimino el patron", life: 6000 });
        });
    }

    render() {
        let { desarrollador, paginacion, errores, detalle, mostrarModalDetalle } = this.state;
        
        const pieDialogoDetalle = (
            <div>
                <Button icon="pi-md-check" label="Aceptar" onClick={this.guardarDetalle} />
                <Button icon="pi-md-close" label="Cancelar" onClick={this.cerrarModal} className="p-button-danger flat-btn" />
            </div>
        );

        const dialogFooterConfirmacionEliminar = (
            <div>
                <Button
                    icon="pi-md-check"
                    onClick={this.eliminar}
                    label="Si estoy seguro"
                />
                <Button
                    icon="pi-md-close"
                    onClick={() =>
                        this.setState({
                            detalle: {},
                            mostrarModalConfirmacion: false,
                            errores: {},
                        })
                    }
                    label="No estoy seguro"
                    className="p-button-danger flat-btn"
                />
            </div>
        );
        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <h1>TABLA DETALLE</h1>
                        </div>
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">

                            <DataTable value={paginacion.datos} header="DETALLE" responsive={true} resizableColumns={true}  >

                                <Column field="ramaUno" header="RAMAS" style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="ramaDos" header="" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="patronal" header="PATRONAL" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="obrero" header="OBRERO" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="topado" header="TOPADO" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                {desarrollador ?<Column body={this.plantillaOpciones} header="OPCIONES" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} /> : null}
                            </DataTable>
                        </div>
                        <Dialog appendTo={document.body} header="Actualizar Tabla Detalle" visible={mostrarModalDetalle}
                            modal={true} onHide={this.cerrarModal} footer={pieDialogoDetalle}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="detalle.ramaUno"><strong>Ramo Uno:</strong></label>
                                </div>

                                <div className="p-col-12 p-md-2">
                                    <InputText type="text" id="detalle.ramaUno" name="detalle.ramaUno"
                                        value={detalle.ramaUno || ""} className={errores.ramaUno ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.ramaUno ? <Message severity="error" text={errores.ramaUno} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="detalle.ramaDos"><strong>Rama Dos:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <InputText type="text" id="detalle.ramaDos" name="detalle.ramaDos"
                                        value={detalle.ramaDos || ""} className={errores.ramaDos ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.ramaDos ? <Message severity="error" text={errores.ramaDos} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="detalle.patronal"><strong>Patronal:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="detalle.patronal" name="detalle.patronal"
                                        value={detalle.patronal || ""} className={errores.patronal ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.patronal ? <Message severity="error" text={errores.patronal} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="detalle.obrero"><strong>Obrero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="detalle.obrero" name="detalle.obrero"
                                        value={detalle.obrero || ""} className={errores.obrero ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.obrero ? <Message severity="error" text={errores.obrero} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="detalle.topado"><strong>Topado:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <InputText type="text" id="detalle.topado" name="detalle.topado"
                                        value={detalle.topado || ""} className={errores.topado ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.topado ? <Message severity="error" text={errores.topado} /> : null}
                                </div>
                            </div>
                        </Dialog>
                        <Dialog
                            header="Confirmación"
                            visible={this.state.mostrarModalConfirmacion}
                            modal={true}
                            style={{ width: "30vw" }}
                            footer={dialogFooterConfirmacionEliminar}
                            onHide={() =>
                                this.setState({
                                    cliente: {},
                                    mostrarModalConfirmacion: false,
                                    errores: {},
                                })
                            }
                        >
                            <h2>¿Estás seguro de eliminar la información?</h2>
                        </Dialog>
                    </div>
                </div>
            </div>
        );
    }
}
